import { ButtonBase, Stack, styled } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { ReactElement, ReactNode } from 'react';

import { Typography, SizingMultiplier } from '@ocx/ui';
import { CardIcon, ArrowRightIcon } from '@ocx/ui-icons';

import { messages } from '../../../pay-at-pump.messages';

const Button = styled(ButtonBase)(({ theme }) => ({
  backgroundColor: theme.palette.action.selected,
  color: theme.palette.text.primary,
  padding: `12px ${theme.spacing(SizingMultiplier.md)}`,
  width: '100%',
  borderRadius: 8,
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
}));

const ActiveCardInfo = ({
  balance,
  hiddenCardNumber,
}: {
  balance?: string | null;
  hiddenCardNumber?: string | null;
}) => {
  if (balance || hiddenCardNumber) {
    return (
      <Typography variant="body2" component="span" color="textSecondary">
        {balance ? (
          <FormattedMessage {...messages.payAtPumpPaymentInstrumentBalance} values={{ balance }} />
        ) : (
          hiddenCardNumber
        )}
      </Typography>
    );
  }
  return null;
};

export type PaymentMethodButtonProps = {
  onClick: () => void;
  startIcon?: ReactElement;
  withEndArrow?: boolean;
  children: ReactNode;
  balance?: string | null;
  hiddenCardNumber?: string | null;
  isExpired?: boolean;
};

export const PaymentMethodButton = ({
  onClick,
  startIcon = <CardIcon />,
  withEndArrow = false,
  children,
  balance,
  isExpired,
  hiddenCardNumber,
}: PaymentMethodButtonProps) => {
  return (
    <Button onClick={onClick}>
      {startIcon}
      <Stack mx={SizingMultiplier.sm} alignItems="start">
        <Typography component="span">{children}</Typography>
        {isExpired ? (
          <Typography variant="body2" color="error">
            <FormattedMessage {...messages.payAtPumpPaymentInstrumentExpiredErrorMessages} />
          </Typography>
        ) : (
          <ActiveCardInfo balance={balance} hiddenCardNumber={hiddenCardNumber} />
        )}
      </Stack>
      {withEndArrow && <ArrowRightIcon sx={{ ml: 'auto', mr: -SizingMultiplier.sm }} />}
    </Button>
  );
};
